import { KuxRailImageArg, KuxMediaAssetType } from '../../interfaces';
import { getRatioByType } from '../image-types';

import { calculateSizePerDevice, getResizerUrl, imageScale, KuxImage } from './image';
import { KuxImageRail } from './image-v2';

export const findByTypeV2 = (asset: KuxMediaAssetType, type: number): KuxImage | undefined => asset.images[type];

export const getTypeByAssetV2 = (asset: KuxMediaAssetType, options: KuxRailImageArg) => {
  if (!options.assetImageSource) {
    return options.assetPresentationImageType;
  }

  const defaultType = asset.metas['asset_presentation_image_type'] as number;
  return defaultType || options.assetPresentationImageType;
};

export const findRailImageV3 = (asset: KuxMediaAssetType, options: KuxRailImageArg): KuxImageRail => {
  const type = getTypeByAssetV2(asset, options);
  const ratio = getRatioByType(options.assetPresentationImageType);

  const originImage = findByTypeV2(asset, type);

  if (originImage) {
    const { width, height } = calculateSizePerDevice(options, originImage.ratio);

    return {
      height,
      width,
      originImageUrl: originImage.url,
      imageUrl: getResizerUrl(originImage.url, height * imageScale, width * imageScale),
    };
  }

  const size = ratio && calculateSizePerDevice(options, ratio);

  return size ?? { height: 0, width: 0 };
};

export const getBase64ImageFromUrl = async (imageUrl: string): Promise<string> => {
  const res = await fetch(imageUrl);
  const blob = await res.blob();

  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.addEventListener(
      'load',
      () => {
        resolve(reader.result as string);
      },
      false,
    );

    reader.onerror = () => {
      return reject(this);
    };
    reader.readAsDataURL(blob);
  });
};
